import React from "react";
// import {TaggedLogger} from "@nextlot/core/utilities";
import BidderLotListCmp from "./BidderCatalogLotsListCmp";
import BidderMyPurchasesCmp from "./BidderMyPurchasesCmp";
import {useTranslation} from "react-i18next";

const TAB_CATALOG = 'catalog';
const TAB_MY_PURCHASES = 'purchases';


// const _logger = TaggedLogger.get('BidderCatalogAndMyPurchasesCmp');

export default function BidderCatalogAndMyPurchasesCmp(props) {
    // _logger.debug('.render()', props);

    const { t, i18n } = useTranslation();
    const [selectedTab, setSelectedTab] = React.useState<string>(TAB_CATALOG);

    const handleClick_Tab = (tab) => (evt) => {
        evt.preventDefault();
        setSelectedTab(tab);
    };

    return (
        <div className="bidder-catalog-and-purchases-outline">
            <ul className="nav nav-tabs bidder-nav-tabs">
                <li className="nav-item">
                    <a className={`nav-link ${selectedTab === TAB_CATALOG ? 'active' : ''}`}
                       href="#"
                       onClick={handleClick_Tab(TAB_CATALOG)}>{t('catalogAndMyPurchases.firstTab')}</a>
                </li>
                <li className="nav-item">
                    <a className={`nav-link ${selectedTab === TAB_MY_PURCHASES ? 'active' : ''}`}
                       href="#"
                       onClick={handleClick_Tab(TAB_MY_PURCHASES)}>{t('catalogAndMyPurchases.secondTab')}</a>
                </li>
            </ul>

            <div className={`bidder-cmp bidder-cmp--${selectedTab}`}>
                {
                    selectedTab === TAB_CATALOG
                        ? <BidderLotListCmp/>
                        : <BidderMyPurchasesCmp/>
                }
            </div>
        </div>
    )

}




// const TAB_CATALOG = 'catalog';
// const TAB_MY_PURCHASES = 'purchases';
//
//
// type CmpPropsType = {
// };
//
// type CmpStateType = {
//     selectedTab: string,
// };
//
//
// const _logger = TaggedLogger.get('BidderCatalogAndMyPurchasesCmp');
//
//
// class BidderCatalogAndMyPurchasesCmp extends React.PureComponent<CmpPropsType, CmpStateType> {
//
//
//     constructor(props) {
//         super(props);
//         // _logger.debug('.constructor()', props);
//
//         this.state = {
//             selectedTab: TAB_CATALOG
//         }
//     }
//
//
//
//     handleClick_Tab = (tab) => (evt) => {
//         evt.preventDefault();
//         this.setState({
//             selectedTab: tab
//         })
//     };
//
//     render() {
//         const { t } = this.props;
//
//         return (
//             <div className="bidder-catalog-and-purchases-outline">
//                 <ul className="nav nav-tabs bidder-nav-tabs">
//                     <li className="nav-item">
//                         <a className={`nav-link ${this.state.selectedTab === TAB_CATALOG ? 'active' : ''}`}
//                            href="#"
//                            onClick={this.handleClick_Tab(TAB_CATALOG)}>{t('catalogAndMyPurchases.firstTab')}</a>
//                     </li>
//                     <li className="nav-item">
//                         <a className={`nav-link ${this.state.selectedTab === TAB_MY_PURCHASES ? 'active' : ''}`}
//                            href="#"
//                            onClick={this.handleClick_Tab(TAB_MY_PURCHASES)}>{t('catalogAndMyPurchases.secondTab')}</a>
//                     </li>
//                 </ul>
//
//                 <div className={`bidder-cmp bidder-cmp--${this.state.selectedTab}`}>
//                     {
//                         this.state.selectedTab === TAB_CATALOG
//                             ? <BidderLotListCmp/>
//                             : <BidderMyPurchasesCmp/>
//                     }
//                 </div>
//             </div>
//         )
//     }
// }
//
// export default withTranslation()(BidderCatalogAndMyPurchasesCmp);

